import { render } from "./office-form.vue?vue&type=template&id=9d4f373c&scoped=true&ts=true"
import script from "./office-form.vue?vue&type=script&lang=ts"
export * from "./office-form.vue?vue&type=script&lang=ts"

import "./office-form.vue?vue&type=style&index=0&id=9d4f373c&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d4f373c"]])

export default __exports__